











































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'CreateKey',
  components: {
  }
})

export default class CreateKey extends Vue {
  @Prop(String) publicKey
  t (key: string) {
    return this.$t(`CreateKey.${key}`)
  }

  btnDisabled = true;
  displayMessage = false;

  async copyCode () {
    try {
      await navigator.clipboard.writeText(this.publicKey)
      this.displayMessage = true
      this.btnDisabled = false
    } catch ($e) {
      alert('Cannot copy')
    }
  }
}
